//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// demos
import DemoTimePickerBasic from './demos/DemoTimePickerBasic.vue'
import DemoTimePickerAllowedTimes from './demos/DemoTimePickerAllowedTimes.vue'
import DemoTimePickerAmPm from './demos/DemoTimePickerAmPm.vue'
import DemoTimePickerFormat from './demos/DemoTimePickerFormat.vue'
import DemoTimePickerNoTitle from './demos/DemoTimePickerNoTitle.vue'
import DemoTimePickerUseSeconds from './demos/DemoTimePickerUseSeconds.vue'
import DemoTimePickerScrollable from './demos/DemoTimePickerScrollable.vue'
import DemoTimePickerRange from './demos/DemoTimePickerRange.vue'
import DemoTimePickerDialogAndMenu from './demos/DemoTimePickerDialogAndMenu.vue'

// code
import {
  timePickerBasic,
  timePickerAllowedTimes,
  timePickerAmPm,
  timePickerFormat,
  timePickerNoTitle,
  timePickerUseSeconds,
  timePickerScrollable,
  timePickerRange,
  timePickerDialogAndMenu,
} from './demos/code'

export default {
  components: {
    AppCardCode,
    DemoTimePickerBasic,
    DemoTimePickerAllowedTimes,
    DemoTimePickerAmPm,
    DemoTimePickerFormat,
    DemoTimePickerNoTitle,
    DemoTimePickerUseSeconds,
    DemoTimePickerScrollable,
    DemoTimePickerRange,
    DemoTimePickerDialogAndMenu,
  },
  setup() {
    return {
      codeSnippents: {
        timePickerBasic,
        timePickerAllowedTimes,
        timePickerAmPm,
        timePickerFormat,
        timePickerNoTitle,
        timePickerUseSeconds,
        timePickerScrollable,
        timePickerRange,
        timePickerDialogAndMenu,
      },
    }
  },
}
